module.exports = __webpack_public_path__ + "static/img/img4.6cb4cd4e.png";